<template>
  <article id="status-press-card">
    <h5>Prensa</h5>
    <div class="card">
      <StartupPress :documents="documents" />
    </div>
  </article>
</template>

<script>
import StartupPress from './StartupPress.vue';

export default {
  name: 'StartupPressCard',
  components: {
    StartupPress,
  },
  props: {
    documents: Array,
  },
};
</script>

<style scoped lang="scss">
#status-press-card {
  .card {
    background: #ffffff;
    border-radius: 8px;
    padding: 10px 20px;
    padding-top: 5px;
    margin-bottom: 15px;
  }
}
h5 {
  font-weight: 400;
  font-size: 12px;
  color: #979797;
  margin: 0;
  margin-bottom: 3px;
}
</style>